export const DAY_OF_WEEK = ['일', '월', '화', '수', '목', '금', '토'];
